// 接口协议代码，与app交互相关
let api = {
  commandQueue: [],
  cmdQueue: {},
  index: 0,
  mNativeFunction: {}
}
let protocol = 'beacon'
api.os = function () {
  var ua = navigator.userAgent
  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/)
  var iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/)
  var os = {}
  if (iphone) os.ios = os.iphone = true
  if (ipad) os.ios = os.ipad = true
  return { ios: os.ios }
}

api.getCookie = function (name) {
  var regexp = new RegExp('(?:^' + name + '|\\s*' + name + ')=(.*?)(?:|$)', 'g')
  var result = regexp.exec(document.cookie)
  return (result === null) ? null : unescape(result[1])
}

api.exec = function (cmd, option, callback) {
  api.index += 1
  var callbackId = new Date().getTime() + '|' + api.index
  option = option || {}
  api.cmdQueue[callbackId] = callback
  var nativeOption = {
    callbackId: callbackId,
    option: option
  }
  var apiContent = protocol + '://[' + cmd + '-' + JSON.stringify(nativeOption) + ']'
  prompt(protocol, apiContent)
}

api.pcExec = function (cmd, option, callback) {
  api.index += 1
  var callbackId = new Date().getTime() + '|' + api.index
  option = option || {}
  api.cmdQueue[callbackId] = callback
  var nativeOption = {
    callbackId: callbackId,
    option: option
  }
  beacon.getAccountInfo(nativeOption)
}

window.AppCallback = function (callbackId, option) {
  // $.alert(callbackId)
  // $.alert(option)
  if (api.cmdQueue[callbackId]) {
    api.cmdQueue[callbackId](option)
  }
}

// 客户端预埋接口
window.ReqWeb = function (key, value) {
  // $.alert('key' + key)
  if (api.mNativeFunction[key] !== undefined) {
    // $.alert('22222')
    api.mNativeFunction[key](value)
  }
}

// 监听native
window.lisenNative = function (key, func) {
  api.mNativeFunction[key] = func
}

let isIos = api.os().ios
let from = getQueryString('dt_from')
let source = getQueryString('source')

// ----- util function -----
// 获取dom节点
function $ (selector) {
  return document.querySelectorAll(selector)
}
// 转成节点
function parseDom (arg) {
  var objE = document.createElement('div')
  objE.innerHTML = arg
  return objE.childNodes
};
// 前面插入节点
function prependChild (o, s) {
  if (s.hasChildNodes()) {
    s.insertBefore(o, s.firstChild)
  } else {
    s.appendChild(o)
  }
}
// 获取链接参数
function getQueryString (name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) {
    var value = r[2]
    value = value.replace(/(%22|%3E|%3C|<|>)/g, 'MM')
    return decodeURIComponent(value)
  } else {
    return null
  }
}
/* eslint-disable*/
function mobileConsole (content) {
  // if(location.protocol=='https:' || location.host=='sec.gushi.com:55553'){return}
  var consoleContent = ''
  var mobileConsoleStyle = '<style> #mobileConsole{position: fixed z-index: 9999991000 right: 0 top: 0 width: 60% height: 50% background-color: rgba(0,0,0,0.6) overflow: auto color: #fff font-size: 12px word-break:break-all padding: 5px 0 border-radius: 0 0 0 10px font-family: "Microsoft Yahei",SimHei,"Helvetica Neue","DejaVu Sans",Tahoma pointer-events:none } #mobileConsole p{ padding: 4px 10px margin: 0 border-bottom: 1px rgba(255,255,255,.1) solid} </style>'
  var $body = $('body')[0]

  function isJson (obj) {
    var isjson = typeof (obj) === 'object' && Object.prototype.toString.call(obj).toLowerCase() === '[object object]' && !obj.length
    return isjson
  }
  // 创建dom结构和样式
  if ($('#mobileConsole').length === 0) {
    $body.appendChild(parseDom('<div id="mobileConsole"></div>'))
    $body.append(parseDom(mobileConsoleStyle))
  }
  // 如果为json对象，则字符串化
  consoleContent = content
  if (isJson(content)) {
    consoleContent = JSON.stringify(content)
  }
  // 填入数据
  // $('#mobileConsole').prepend('<p>' + consoleContent + '</p>')
  prependChild(parseDom('<p>' + consoleContent + '</p>'), $('#mobileConsole')[0])
}

// ----------声明 beacon-----------
let beacon = {}

// web是app分享出去，nod是没有底部下拉框但有顶部硬logo，clean什么都不带，pcClient是pc客户端
beacon.checkIfCanUseApi = function () {
  if (from === 'web' || from === 'nod' || from === 'clean' || source === 'pcClient') {
    return false
  } else {
    return true
  }
}

beacon.setTitle = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }

  if (isIos) {
    api.exec('setTitle', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      window.NativeProxy.setTitle(option.title)
    } catch (e) {}
    callBack({})
  }
}

// >>当 `apn` &nbsp&nbsp时，表示网络制式，可以判断电信联通；
//
// >>当 `networkType` &nbsp&nbsp时，表示2G(2)/3G(3)/4G(4)/wifi(1)；
//
// >>当 `networkConnected` &nbsp&nbsp时，表示是否有网；   ios返回networkConnected是个字符串'0'或者'1' '0'表示无网 '1'表示有网
beacon.netInfo = function (option, callBack) {
  var data = ''
  if (!this.checkIfCanUseApi()) {
    data = {
      networkConnected: true
    }
    callBack(data)
    return
  }
  if (isIos) {
    api.exec('netInfo', option, function (data) {
      if (data.networkConnected === '0') {
        data.networkConnected = false
      } else {
        data.networkConnected = true
      }
      callBack(data)
    })
  } else {
    try {
      data = window.NativeProxy.netInfo()
      data = JSON.parse(data)
      callBack(data)
    } catch (e) {
      // return
      data = {
        networkConnected: true
      }
      callBack(data)
    }
  }
}

beacon.openSharePanel = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('openSharePanel', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      window.NativeProxy.openSharePanel(JSON.stringify(option))
    } catch (e) {}
    callBack({})
  }
}
// 获取回退权限
beacon.setBackButtonListenerEnable = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('setBackButtonListenerEnable', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      window.NativeProxy.setBackButtonListenerEnable(JSON.stringify(option))
    } catch (e) {}
    callBack({})
  }
}
beacon.closeWindow = function(option, callBack) { //特别注意ios用closeWindow   安卓用finish
    if (!this.checkIfCanUseApi()) {
        return;
    }
    if (isIos) {
        api.exec("closeWindow", option, function(data) {
            callBack(data);
        });
    } else {
        try {
            window.NativeProxy.finish();
        } catch (e) {}
        callBack({});
    }
};
beacon.setKeyValue = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('setKeyValue', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      window.NativeProxy.setKeyValue(JSON.stringify(option))
    } catch (e) {}
    callBack({})
  }
}
beacon.getKeyValue = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('getKeyValue', option, function (data) {
      if (data === undefined) {
        callBack('')
      } else {
        callBack(data)
      }
    })
  } else {
    try {
      var valueGotten = window.NativeProxy.getKeyValue(JSON.stringify(option))
      if (typeof valueGotten !== 'object') {
        valueGotten = JSON.parse(valueGotten)
      }
    } catch (e) {}
    callBack(valueGotten)
  }
}
// 显示分享panel
beacon.showSharePanel = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('showSharePanel', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      window.NativeProxy.showSharePanel(JSON.stringify(option))
    } catch (e) {}
    callBack({})
  }
}
// 新的显示分享panel
beacon.showNewSharePanel = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('showNewSharePanel', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      window.NativeProxy.showNewSharePanel(JSON.stringify(option))
    } catch (e) {}
    callBack({})
  }
}
// 打开登陆界面
beacon.openLoginPanel = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('openLoginPanel', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      window.NativeProxy.openLoginPanel(JSON.stringify(option))
    } catch (e) {}
    callBack({})
  }
}
// 弹框提示
beacon.popupBox = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('popupBox', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      window.NativeProxy.popupBox(JSON.stringify(option))
    } catch (e) {}
    callBack({})
  }
}
beacon.popupInputBox = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('popupInputBox', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      window.NativeProxy.popupInputBox(JSON.stringify(option))
    } catch (e) {}
    callBack({})
  }
}

beacon.backWindow = function (option, callBack) { // 特别注意ios用back   安卓用finish
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('back', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      window.NativeProxy.finish()
    } catch (e) {}
    callBack({})
  }
}
beacon.getLocation4StockMap = function (option, callBack) { // 特别注意ios用back   安卓用finish
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    // $.alert('getLocation4StockMap')
    api.exec('getLocation4StockMap', option, function (data) {
      // $.alert(data)
      callBack(data)
    })
  } else {
    var data = ''
    try {
      data = window.NativeProxy.getLocation4StockMap(JSON.stringify(option))
    } catch (e) {
          // $.mobileConsole(e)
      data = '[]'
    }
    callBack(data)
  }
}
// 强制刷新token
beacon.refreshToken = function() {
  if (!this.checkIfCanUseApi()) {
    return;
  }
  if (isIos) {
    beaconApi.exec("refreshToken", null, function() {});
  } else {
    try {
      NativeProxy.refreshToken();
    } catch (e) {}
  }
};
beacon.getAccountInfo = function (option, callBack) {
  var accountInfo = ''
    // 给pc用的,并且必须在dt_from为web时才会进去
  if (!this.checkIfCanUseApi() && source !== 'pcClient') {
    accountInfo = {AID:0,GUID:'',DUA:'vn=0',iDLControlKey:1};

    // var accountInfo ={
    //     AID:18936,
    //     GUID:'13855B014985AD42EDF8A8E4F194D159',
    //     DUA:'SN=IOSCJPH10_GA&VN=102051109&BN=0&VC=APPLE&MO=iPhone&RL=375_812&CHID=1000&LCID=0&RV=&OS=11.2&DV=V1',
    //     ticket:'uEIONtQ7yu9bSuzVlxCXf45kvX!Nn4HRNRvxCUdmyhI.'
    // }
    callBack(accountInfo)
    return
  }
  if (source === 'pcClient') {
        // mobileConsole('进去前')
        // new QWebChannel(qt.webChannelTransport, function (channel) {
        // mobileConsole('进去后')
        // window.NativeProxy = channel.objects.window.NativeProxy
        // var accountInfo=window.NativeProxy.getAccountInfo()
    try {
      api.pcExec('getAccountInfo', option, function (data) {
        // 终端得到的字段转成后台统一字段，特别注意DUA需要encodeURIComponent
        callBack({
          AID: data.AID,
          GUID: data.GUID,
          // DUA: encodeURIComponent(data.DUA),
          DUA: data.DUA,
          ticket: data.TICKET,
          dtCellphoneState: data.dtCellphoneState
        })
      })
    } catch (e) {
      callBack({
        // AID:accountInfo.AID,
        // GUID:accountInfo.GUID,
        // DUA:encodeURIComponent(accountInfo.DUA),
        // ticket:accountInfo.ticket
        AID: 18914,
        GUID: '24CE31101326D9B13DEFCA5D9D8C893B',
        DUA: 'SN=IOSCJPH182_GA&VN=182080222&BN=0&VC=APPLE&MO=iPhone&RL=375_667&CHID=1000&LCID=0&RV=&OS=9.3.2&DV=V1&status=0',
        ticket: 'eQU2uxOVYDgcXhkSQyHC7XPMfVByIKuaP6PVtgbVrKY.',
        dtCellphoneState: '',
        dtnickname: '',
        dtheadimgurl: ''
      })
    }
        // })
  } else if (isIos) {
    api.exec('getAccountInfo', option, function (data) {
      // 终端得到的字段转成后台统一字段，特别注意DUA需要encodeURIComponent
      callBack({
        AID: data.dtid,
        GUID: data['DT-GUID'],
        // DUA: encodeURIComponent(data['DT-UA']),
        DUA: data['DT-UA'],
        MAC: data.MAC,
        ticket: data.dtticket,
        IMEI: data.imei,
        dtCellphoneState: data.dtCellphoneState,
        dtnickname: data.dtnickname,
        dtheadimgurl: data.dtheadimgurl,
        dtMemberType: data.dtMemberType,
        dtMemberEndTime: data.dtMemberEndTime,
        iosChecking: data.iosChecking,
        dtUserRealName: data.dtUserRealName,
        dtUserIDNumber: data.dtUserIDNumber,
        ztIsInReview: data.ztIsInReview,
        accountProfile: data.accountProfile,//默认传入用户简介
        UUID:data.uuid, //设备唯一标识
        iDLControlKey:data.iDLControlKey,
        token: data.token,
        version: data.key_version_name // 版本号
      })
    })
  } else {
    try {
      accountInfo = window.NativeProxy.getAccountInfo()
          // $.mobileConsole(accountInfo)
      if (typeof accountInfo !== 'object') {
        accountInfo = JSON.parse(accountInfo)
      }
    } catch (e) {
          // $.mobileConsole(e)
      accountInfo = {
        dtticket: null,
        dtid: null,
        "DT-GUID": "",
        "DT-UA": "",
        dtCellphoneState: 0,
        dtnickname: '',
        dtheadimgurl: '',
        dtMemberType: '',
        dtMemberEndTime: '',
        dtUserRealName: '',
        dtUserIDNumber: '',
        accountProfile: '',
        iDLControlKey:0,
        token: '',
        version: ''
      }
    }
    if (!accountInfo.dtheadimgurl) {
      accountInfo.dtheadimgurl = ''
    }
    callBack({
      version: accountInfo.version, // 当前手机上版本
      fnVersion: accountInfo.function_version, // 当前功能版本
      AID: accountInfo.dtid,
      GUID: accountInfo['DT-GUID'],
      // DUA: encodeURIComponent(accountInfo['DT-UA']),
      DUA: accountInfo['DT-UA'],
      MAC: accountInfo.MAC,
      IMEI: accountInfo.IMEI,
      ticket: accountInfo.dtticket,
      dtCellphoneState: accountInfo.dtCellphoneState,
      dtnickname: accountInfo.dtnickname,
      dtheadimgurl: accountInfo.dtheadimgurl,
      dtMemberType: accountInfo.dtMemberType,
      dtMemberEndTime: accountInfo.dtMemberEndTime,
      dtUserRealName: accountInfo.dtUserRealName,
      dtUserIDNumber: accountInfo.dtUserIDNumber,
      accountProfile: accountInfo.accountProfile,
      UUID:accountInfo.uuid, //设备唯一标识
      iDLControlKey:accountInfo.iDLControlKey,
      token: accountInfo.token,
      version: accountInfo.key_version_name,  // 版本号
      app: 'android'
    })
  }
}
beacon.sendInfoToNative = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('sendInfoToNative', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      window.NativeProxy.sendInfoToNative(JSON.stringify(option))
    } catch (e) {}
    callBack({})
  }
}

beacon.sendCopyInfo = function (option, callBack) { /// {text:'ffff'}
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('sendCopyInfo', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      window.NativeProxy.sendCopyInfo(JSON.stringify(option))
    } catch (e) {}
    callBack({})
  }
}

// 发送优惠券信息
beacon.sendCoupon = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('sendCoupon', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      window.NativeProxy.sendCoupon(JSON.stringify(option))
    } catch (e) {}
    callBack({})
  }
}

beacon.openPdfFileBySystem = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('openPdfFileBySystem', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      window.NativeProxy.openPdfFileBySystem(option.url)
    } catch (e) {}
    callBack({})
  }
}

beacon.isPdfFileExists = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('isPdfFileExists', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      var isCached = window.NativeProxy.isPdfFileExists(option.url)
    } catch (e) {
      isCached = false
    }
    if (isCached) {
      callBack({ status: 0 })
    } else {
      callBack({ status: -1 })
    }
  }
}

beacon.downloadFile = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('downloadFile', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      window.NativeProxy.downloadFile(option.url)
    } catch (e) {}
    callBack({})
  }
}

beacon.setRefreshButtonAnim = function (option, callBack) { // option status=1 开始动画  0停止动画
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('setRefreshButtonAnim', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      window.NativeProxy.setRefreshButtonAnim(JSON.stringify(option))
    } catch (e) {}
    callBack({})
  }
}

beacon.getAllSearchHistoryItem = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('getAllSearchHistoryItem', option, function (data) {
      callBack(data)
    })
  } else {
    var historyData
    try {
      historyData = window.NativeProxy.getAllSearchHistoryItem(JSON.stringify(option))
    } catch (e) {
      historyData = []
    }
    callBack(JSON.parse(historyData))
  }
}

beacon.addSearchHistoryItem = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('addSearchHistoryItem', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      window.NativeProxy.addSearchHistoryItem(JSON.stringify(option))
    } catch (e) {}
    callBack({})
  }
}

beacon.clearSearchHistoryItem = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('clearSearchHistoryItem', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      window.NativeProxy.clearSearchHistoryItem(JSON.stringify(option))
    } catch (e) {}
    callBack({})
  }
}
// 投资组合
beacon.getAllPortfolio = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('getAllPortfolio', option, function (data) {
      callBack(data)
    })
  } else {
    var portfolioData = window.NativeProxy.getAllPortfolio(JSON.stringify(option))
    callBack(JSON.parse(portfolioData))
  }
}

beacon.addPortfolio = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('addPortfolio', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      var data = window.NativeProxy.addPortfolio(JSON.stringify(option))
      callBack(JSON.parse(data))
    } catch (e) {
          //
    }
  }
}

beacon.isPortfolio = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('isPortfolio', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      var data = window.NativeProxy.isPortfolio(JSON.stringify(option))
      callBack(JSON.parse(data)) // 0，不是。1，是。
    } catch (e) {
          //
    }
  }
}

beacon.sendSignResult = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('sendSignResult', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      window.NativeProxy.sendSignResult(JSON.stringify(option))
    } catch (e) {}
    callBack({})
  }
}

beacon.setWebViewTitleBar = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }

  var bottomArray = []
  var leftArray = []
  var rightArray = []
  var middleArray = []
  for (var i = 0, j = option.length; i < j; i++) {
    if (option[i].position === 'left') {
      leftArray.push(option[i])
    } else if (option[i].position === 'right') {
      rightArray.push(option[i])
    } else if (option[i].position === 'middle') {
      middleArray.push(option[i])
    } else if (option[i].position === 'bottom') {
      bottomArray.push(option[i])
    }
  }
  var optionArray = []
  optionArray.push({ 'position': 'left', option: leftArray })
  optionArray.push({ 'position': 'right', option: rightArray })
  optionArray.push({ 'position': 'middle', option: middleArray })
  optionArray.push({ 'position': 'bottom', option: bottomArray })

    // backButton closeButton shareButton refreshButton rightTextButton
  if (isIos) {
    api.exec('setWebViewTitleBar', optionArray, function (data) {
      callBack(data)
    })
  } else {
    try {
      window.NativeProxy.setWebViewTitleBar(JSON.stringify(optionArray))
    } catch (e) {}
    callBack({})
  }
}
// 统计使用 统计有两种方式 type=0表示事件统计  type=1表示计数统计
beacon.reportAction = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('reportAction', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      window.NativeProxy.reportAction(JSON.stringify(option))
    } catch (e) {}
    callBack({})
  }
}

// 上报积分任务
beacon.reportFinishedTask = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('reportFinishedTask', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      window.NativeProxy.reportFinishedTask(JSON.stringify(option))
    } catch (e) {}
    callBack({})
  }
}

// 开启允许长按
beacon.setLongClickEnabled = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('setLongClickEnabled', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      window.NativeProxy.setLongClickEnabled(option)
    } catch (e) {}
    callBack({})
  }
}

/**
 * [logToNative 向native写日志]
 * @param  {[type]} strLevel [d w e代表三个日志级别(debug warning error)]
 * @param  {[type]} msg      [日志内容字符串]
 * @return {[type]}          [无]
 */
beacon.logToNative = function (option) {
  if (!this.checkIfCanUseApi()) {
    return
  }

  if (isIos) {
    api.exec('logToNative', option, null)
  } else {
    try {
      window.NativeProxy.logToNative(JSON.stringify(option))
    } catch (e) {
      console.log(option)
    }
  }
}

// 给终端输入框中加内容 内容为text
beacon.setInputValue = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('setInputValue', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      window.NativeProxy.setInputValue(JSON.stringify(option))
    } catch (e) {}
    callBack({})
  }
}

// 显示图片
beacon.showImages = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('showImages', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      window.NativeProxy.showImages(JSON.stringify(option))
    } catch (e) {}
    callBack({})
  }
}

// 评论详情页点自己的评论调起native的删除菜单
beacon.showDeleteCommentPanel = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('showDeleteCommentPanel', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      window.NativeProxy.showDeleteCommentPanel(JSON.stringify(option))
    } catch (e) {}
    callBack({})
  }
}

// 切换点赞状态
beacon.doLikeComment = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('doLikeComment', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      window.NativeProxy.doLikeComment(JSON.stringify(option))
    } catch (e) {
      // var data = {}
    }
    callBack({})
  }
}

// 查询点赞状态
beacon.queryLikeComment = function (option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return
  }
  if (isIos) {
    api.exec('queryLikeComment', option, function (data) {
      callBack(data)
    })
  } else {
    try {
      var data = window.NativeProxy.queryLikeComment(JSON.stringify(option))
    } catch (e) {
          // data = false
    }
    if (data == null) { // 返回异常时是一个null，当作isAdd 0 处理
      callBack({ isAdd: 0 })
    } else {
      callBack(JSON.parse(data))
    }
  }
}
// 埋点添加 syj - 20190918
beacon.webMobClick = function(option, callBack) {
  if (!this.checkIfCanUseApi()) {
    return;
  }
  if (isIos) {
    api.exec("webMobClick", option, function(data) {
      callBack(data.result);
    });
  } else {
    try {
      var data =  window.NativeProxy.webMobClick(JSON.stringify(option));
    } catch (e) {
      // data = false;
    }
    if (data == null) {
      callBack(0)
    } else {
      callBack(data);
    }
  }
};

let fuc = 'beacon'
let fucApi = 'api'

window[fuc] = beacon
window[fucApi] = api

export default {
  beaconApi: api,
  beacon
}



// WEBPACK FOOTER //
// ./src/plugins/sdk/sdk.js